const { peopleSmsOptInMark } = require('./peopleListFilter');

function firstUsPhoneDigits(value) {
  const parts = String(value ?? '').split(/[;\n,]/);
  for (const part of parts) {
    const digits = part.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
    if (digits.length === 10) return digits;
  }
  return '';
}

function personPhoneDigits(person) {
  return (
    firstUsPhoneDigits(person && person.Phone) ||
    firstUsPhoneDigits(person && person.smsPhoneDigits)
  );
}

function formatUsPhone(digits) {
  if (!digits || digits.length !== 10) return '';
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function peopleCellDoubleClickAction(header) {
  if (header && header.display === 'sms-opt') return 'sms-opt';
  return 'row';
}

function manualSmsOptBody(person, optIn) {
  return {
    optIn: Boolean(optIn),
    confirmed: Boolean(optIn),
    phoneDigits: personPhoneDigits(person),
  };
}

function manualSmsOptCanOptIn(person) {
  return Boolean(personPhoneDigits(person));
}

function smsOptPopupPhone(person) {
  return formatUsPhone(personPhoneDigits(person));
}

function smsOptPopupStatus(person) {
  const mark = peopleSmsOptInMark(person);
  if (mark === 'in') return 'Opted in';
  if (mark === 'out') return 'Opted out';
  return 'Not set';
}

function hasOptOutStamp(value) {
  if (value == null) return false;
  const text = String(value).trim();
  return Boolean(text) && !text.startsWith('0000-00-00');
}

function applyManualSmsOptResult(person, result, fallbackOptOutAt) {
  const optedIn = Number(result && result.smsOptIn) === 1;
  const next = { ...(person || {}) };
  next.smsOptIn = optedIn ? 1 : 0;
  if (result && Object.prototype.hasOwnProperty.call(result, 'smsOptOutAt')) {
    next.smsOptOutAt = result.smsOptOutAt;
  }
  if (result && result.smsOptInAt != null) next.smsOptInAt = result.smsOptInAt;
  if (result && result.smsPhoneDigits != null) {
    next.smsPhoneDigits = result.smsPhoneDigits;
  }
  if (!optedIn && !hasOptOutStamp(next.smsOptOutAt)) {
    next.smsOptOutAt = fallbackOptOutAt || new Date().toISOString();
  }
  return next;
}

function patchPeopleSmsOpt(rows, peopleId, result, fallbackOptOutAt) {
  return (Array.isArray(rows) ? rows : []).map((row) =>
    row && row.id === peopleId
      ? applyManualSmsOptResult(row, result, fallbackOptOutAt)
      : row,
  );
}

module.exports = {
  peopleCellDoubleClickAction,
  manualSmsOptBody,
  manualSmsOptCanOptIn,
  smsOptPopupStatus,
  smsOptPopupPhone,
  applyManualSmsOptResult,
  patchPeopleSmsOpt,
};
